export const PaymentConstants = {
    CURRENT_PAYMENT_VERSION: '0.1',
    BLOCK_TYPE_FOR_TRACKING: 'payment',
    STATE_ID_PREFIX: 'payment:',
    DEFAULT_BLOCK_TITLE: 'Payment',
    TEMPLATE_TYPE: 'payment',
};
export const PAYMENT_TEMPLATE_TYPE = PaymentConstants.TEMPLATE_TYPE;
export const PAYMENT_GENERATE_COMPONENT = 'paymentGenerateComponent';
